<template>
  <v-dialog v-model="dialog" max-width="800" :fullscreen="mobile" persistent>
    <v-card>
      <v-card-title class="headline">
        {{ $vuetify.lang.t('$vuetify.sqlHelperDialog.title') }}
        <v-spacer></v-spacer>
        <v-btn icon @click="$emit('sql-helper-dialog-close')">
          <v-icon>{{ closeIcon }}</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-card flat class="my-0">
          <v-card-title>{{ $vuetify.lang.t('$vuetify.sqlHelperDialog.pureEventsOld') }}</v-card-title>
          <v-card-text class="my-0 py-0">
            <code ref="pureOldQuery">{{ allPureOld }}</code>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green"
              text
              @click="saveQuery(allPureOld, 'pureOldQuery')">
              <v-icon left>{{ copyIcon }}</v-icon>
              {{ $vuetify.lang.t('$vuetify.map.textCopyPopup.copy') }}
            </v-btn>
          </v-card-actions>
        </v-card>
        <v-card flat class="my-0">
          <v-card-title>{{ $vuetify.lang.t('$vuetify.sqlHelperDialog.pureEventsNew') }}</v-card-title>
          <v-card-text class="my-0 py-0">
            <code ref="pureNewQuery">{{ allPureNew }}</code>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green"
              text
              @click="saveQuery(allPureNew, 'pureNewQuery')">
              <v-icon left>{{ copyIcon }}</v-icon>
              {{ $vuetify.lang.t('$vuetify.map.textCopyPopup.copy') }}
            </v-btn>
          </v-card-actions>
        </v-card>
        <v-card flat class="my-0" v-if="event.isDatabaseCritical">
          <v-card-title>{{ $vuetify.lang.t('$vuetify.sqlHelperDialog.criticalCurrent') }}</v-card-title>
          <v-card-text class="my-0 py-0">
            <code ref="criticalCurrent">{{ currentCritical }}</code>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green"
              text
              @click="saveQuery(currentCritical, 'criticalCurrent')">
              <v-icon left>{{ copyIcon }}</v-icon>
              {{ $vuetify.lang.t('$vuetify.map.textCopyPopup.copy') }}
            </v-btn>
          </v-card-actions>
        </v-card>
        <v-card flat class="my-0">
          <v-card-title>{{ $vuetify.lang.t('$vuetify.sqlHelperDialog.criticalAll') }}</v-card-title>
          <v-card-text class="my-0 py-0">
            <code ref="criticalAll">{{ allCritical }}</code>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green"
              text
              @click="saveQuery(allCritical, 'criticalAll')">
              <v-icon left>{{ copyIcon }}</v-icon>
              {{ $vuetify.lang.t('$vuetify.map.textCopyPopup.copy') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mdiClose, mdiContentCopy } from '@mdi/js'
import { CriticalEvent } from '@/models/map/CriticalEvent'
import snackbarMixin from '@/mixins/snackbarMixin'
import { newPureEventsRange, oldPureEventsRange } from '@/utils/sqlHelper'

export default {
  name: 'sqlHelperDialog',
  mixins: [snackbarMixin],
  props: {
    dialog: Boolean,
    event: CriticalEvent,
    userId: Number
  },
  data: () => ({
    closeIcon: mdiClose,
    copyIcon: mdiContentCopy
  }),
  computed: {
    mobile () {
      return ['xs'].includes(this.$vuetify.breakpoint.name)
    },
    allPureOld () {
      return oldPureEventsRange(this.event.timeEventStart.getTime(), this.event.timeEventEnd.getTime(), this.event.datetimestart.getTime(), this.userId)
    },
    allPureNew () {
      return newPureEventsRange(this.event.timeEventStart.getTime(), this.event.timeEventEnd.getTime(), this.event.datetimestart.getTime(), this.userId)
    },
    allCritical () {
      return `SELECT * FROM pure_critical_event_new WHERE datetimestart = ${this.event.datetimestart.getTime()} AND userid = ${this.userId};`
    },
    currentCritical () {
      return `SELECT * FROM pure_critical_event_new WHERE id_critical_event = ${this.event.idCriticalEvent};`
    }
  },
  methods: {
    saveQuery (text, domElement) {
      this.$copyText(text, this.$refs[domElement])
        .then((e) => {
          this.openSuccessSnackbar('$vuetify.map.textCopyPopup.success')
        })
        .catch((e) => {
          console.error(e)
          this.openFailureSnackbar('$vuetify.map.textCopyPopup.failure')
        })
    }
  }
}
</script>

<style scoped>

</style>
